import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment as env } from '@environments/environment'
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiResult} from '../../../shared/model/Index';
import { IAddress } from '../model/address';

@Injectable({ providedIn: 'root' })

export class AddressService {
    public showSpinner = new BehaviorSubject(false);
    constructor(private http: HttpClient) { }

    getAddressById(id:string) {
        return this.http.get<ApiResult<IAddress[]>>(env.apiUrl + 'address/' + id).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }
}